import React, { useState } from "react";
import DeleteButton from "../../../../components/admin/usable/actions/DeleteButton";
import BookTour from "./BookTour";

const FloatingTourBooking = ({ TourData }) => {
  const [isShow, setIsShow] = useState(false);
  return (
    <>
      {isShow && (
        <div
          className="fixed inset-0 bg-black/50 flex justify-center items-center z-40"
          onClick={() => setIsShow(false)}
        >
          <div
            className="bg-white w-[90%] max-w-[350px] rounded-xl shadow-lg overflow-hidden relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="absolute top-2 right-2">
              <DeleteButton onClick={() => setIsShow(false)} />
            </div>

            <div className="max-h-[70vh] overflow-y-auto p-3">
              <BookTour TourData={TourData} />
            </div>
          </div>
        </div>
      )}

      <button
        onClick={() => setIsShow(true)}
        className="fixed bottom-20 left-1/2 -translate-x-1/2 bg-blue-800 text-white px-4 py-2 rounded-full text-xs z-30 lg:hidden shadow-md"
      >
        {TourData.data !== "" ? "View Booking Details" : "No Booking Data"}
      </button>
    </>
  );
};

export default FloatingTourBooking;
